export enum GlobalHeaderModel {
  SkipGlobalInterceptor = 'X-Skip-Global-Interceptor'
}
